var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGoogleDrive2 = function SvgGoogleDrive2(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-24": 20,
    viewBox: "0 0 19.7 18",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.633 0c.622 0 1.195.34 1.493.886l5.3 9.718a1.7 1.7 0 0 1-.024 1.671l-2.841 4.873a1.7 1.7 0 0 1-1.47.842H4.532a1.7 1.7 0 0 1-1.47-.842l-2.83-4.853a1.7 1.7 0 0 1 .005-1.722L5.99.835A1.7 1.7 0 0 1 7.454 0zM4.857 16.59h10.235a.3.3 0 0 0 .26-.149l2.511-4.305H7.191zm-3.416-5.304a.3.3 0 0 0 0 .304l2.346 4.024L8.703 6.23a.7.7 0 0 1 .148-.189L6.73 2.332zm6.484-.55h3.608L9.65 7.438zm5.22 0h4.757l-5.006-9.18a.3.3 0 0 0-.263-.156H7.81z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGoogleDrive2);
export default ForwardRef;